import { Text } from "../externalComponents/tailwind/text";

function NoteNode({ id, data, selected }) {
  return (
    <div
      className={"note-node " + (selected ? "selected " : "")}
      onClick={() => data.clickNode(id)}
    >
      <Text className="text-xs">{data?.note}</Text>
    </div>
  );
}

export default NoteNode;
